import apiHandler from "../core/apiHandler";

const productColorApi = apiHandler("product-colors");
export default productColorApi;
